module.exports = __webpack_public_path__ + "img/n9.0da12e81.svg";